const supportsFieldSizing =
	typeof CSS !== 'undefined' && CSS.supports('field-sizing', 'content');

export function adjustTextareaHeight($element: HTMLTextAreaElement): void {
	if (supportsFieldSizing) return;

	$element.style.height = 'auto';

	const styles = getComputedStyle($element);
	const minHeight = parseFloat(styles.minHeight) || 0;
	const maxHeight = styles.maxHeight === 'none' ? Infinity : parseFloat(styles.maxHeight);
	const scrollHeight = $element.scrollHeight;
	const height = Math.min(Math.max(scrollHeight, minHeight), maxHeight);

	$element.style.height = `${height}px`;
	$element.style.overflowY = scrollHeight > maxHeight ? 'auto' : 'hidden';
}
